import angular from 'angular';
import { IApuracaoPonto, IApuracaoPontoGetResponse } from '../models/apuracaoponto.model';
import { IApuracaoPontoHistorico } from '../models/apuracaopontohistorico.model';
import { LoadParams } from '../../../../shared/models/loadparams.model';
import {
	ISaldoInicialImportacaoArquivoResponse,
	ISaldoInicialImportacaoJsonItemRequest,
	ISaldoInicialImportacaoJsonItemResponse,
	ISaldoInicialTrabalhadorApiResponse,
} from './saldo-inicial/models/saldo-inicial.model';

export class ApuracoesPontoService {
	static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

	public entity: IApuracaoPonto;
	public entities: Array<IApuracaoPonto> = [];
	public loaded = false;
	public constructors: any = {};
	public after: any = {};
	public filters: any = {};
	public loadParams: LoadParams;
	public loading_deferred: any = null;
	public filter: any = '';

	constructor(
		public $http: angular.IHttpService,
		public nsjRouting: any,
		public $rootScope: angular.IRootScopeService,
		public $q: angular.IQService,
	) {
		this.loadParams = new LoadParams();
	}

	reload(pagesToLoad: number = 3) {
		if (this.loading_deferred) {
			this.loading_deferred.resolve();
		}

		this.loadParams.finished = false;
		this.loadParams.to_load = pagesToLoad;
		this.after = {};
		this.loaded = false;
		this.entities.length = 0;
		this.loadParams.busy = false;

		return this.load();
	}

	_load(constructors: any, offset: any, filter: any) {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'GET',
				url: this.nsjRouting.generate('ponto_apuracoesponto_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				resolve(response.data);
			})
			.catch((response: any) => {
				reject(response);
			});
		});
	}

	load() {
		if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
			this.loadParams.busy = true;

			this._load(this.constructors, this.after, this.filter)
				.then((data: any): void => {
					if (data.length > 0) {
						for (var i = 0; i < data.length; i++) {
							this.entities.push(data[i]);
						}

						this.after['inicioapuracao'] = this.entities[this.entities.length - 1]['inicioapuracao'];
						this.after['apuracaoponto'] = this.entities[this.entities.length - 1]['apuracaoponto'];
					}

					if (data.length < 20) {
						this.loadParams.finished = true;
						this.$rootScope.$broadcast('apuracoesponto_index_list_finished', this.entities);
					} else {
						this.loadParams.finished = false;
					}

					this.loaded = true;
					this.loadParams.to_load--;

                    if (this.loadParams.to_load === 0 || data.length <= 20) {
                        this.$rootScope.$broadcast('apuracoesponto_index_loaded', this.entities);
                    }
				})
				.catch((error: any): void => {
					if (error.xhrStatus !== 'abort') {
						this.loadParams.finished = true;
						this.$rootScope.$broadcast('apuracoesponto_index_error', error);
					}
				})
				.finally((): void => {
					if (this.loaded || this.loadParams.finished) {
						this.loadParams.busy = false;
					}

					this.load();
				});
		}

		return this.entities;
	}

	loadMore(pagesToLoad: number = 1) {
		this.loadParams.to_load = pagesToLoad;
		this.load();
	}

	fechar(entity: IApuracaoPonto) {
		this.loading_deferred = this.$q.defer();
		entity['$$__submitting'] = true;

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_apuracoesponto_fechar', { 'id': entity.apuracaoponto }, true),
				data: angular.copy(entity),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_fechado', response);
				resolve(response.data);
			})
				.catch((response: any) => {
					this.$rootScope.$broadcast('apuracoesponto_fechar_erro', response);
					reject(response);
				}).finally(() => {
					entity['$$__submitting'] = false;
				});
		});
	}

	reabrir(entity: IApuracaoPonto) {
		this.loading_deferred = this.$q.defer();
		entity['$$__submitting'] = true;

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_apuracoesponto_reabrir', { 'id': entity.apuracaoponto }, true),
				data: angular.copy(entity),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_reaberto', response);
				resolve(response.data);
			})
				.catch((response: any) => {
					this.$rootScope.$broadcast('apuracoesponto_reabrir_erro', response);
					reject(response.data);
				}).finally(() => {
					entity['$$__submitting'] = false;
				});
		});
	}

	download(entity: IApuracaoPonto) {
		this.loading_deferred = this.$q.defer();
		entity['$$__submitting'] = true;

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'get',
				url: this.nsjRouting.generate('ponto_apuracoesprocessamento_downloadfolhaslote', { 'apuracaoponto': entity.apuracaoponto }, true),
				responseType: 'blob',
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesprocessamento_downloadfolhaslote_sucesso', response);
				resolve(response.data);
			})
				.catch((response: any) => {
					this.$rootScope.$broadcast('apuracoesprocessamento_downloadfolhaslote_erro', response);
					reject(response);
				}).finally(() => {
					entity['$$__submitting'] = false;
				});
		});
	}

	get(identifier: string) {
		this.loading_deferred = this.$q.defer();

		return this.$q<IApuracaoPontoGetResponse>((resolve, reject) => {
			this.$http.get<IApuracaoPontoGetResponse>(
				this.nsjRouting.generate('ponto_apuracoesponto_get', { 'id': identifier }, true),
				{ timeout: this.loading_deferred.promise }
			)
			.then((response: angular.IHttpResponse<IApuracaoPontoGetResponse>) => {
				this.$rootScope.$broadcast('ponto_apuracoesponto_get_loaded', response.data);
				resolve(response.data);
			})
			.catch((error) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_get_error', error);
                reject(error);
            });
		});
	}

	getHistoricos(apuracaoponto: string) {
		this.loading_deferred = this.$q.defer();

		return this.$q<IApuracaoPontoHistorico[]>((resolve, reject) => {
			this.$http.get<IApuracaoPontoHistorico[]>(
				this.nsjRouting.generate('ponto_apuracoesponto_historicos', { 'id': apuracaoponto }, true),
				{ timeout: this.loading_deferred.promise }
			)
			.then((response) => {
				this.$rootScope.$broadcast('apuracoesponto_historicos_loaded', response);
				resolve(response.data);
			})
				.catch((error) => {
					this.$rootScope.$broadcast('apuracoesponto_historicos_error', error);
					reject(error);
				});
		});
	}

	listarTrabalhadoresSaldoInicial(apuracaoponto: string) {
		this.loading_deferred = this.$q.defer();

		return this.$q<ISaldoInicialTrabalhadorApiResponse[]>((resolve, reject) => {
			this.$http.get<ISaldoInicialTrabalhadorApiResponse[]>(
				this.nsjRouting.generate('apuracoesponto_listar_trabalhadores_saldo_inicial', { apuracaoponto }, true),
				{ timeout: this.loading_deferred.promise }
			)
			.then((response) => {
                this.$rootScope.$broadcast('apuracoesponto_listar_trabalhadores_saldo_inicial_loaded', response);
				resolve(response.data);
			})
				.catch((error) => {
                this.$rootScope.$broadcast('apuracoesponto_listar_trabalhadores_saldo_inicial_error', error);
					reject(error);
				});
		});
	}

	importarSaldoInicialJson(apuracaoponto: string, itens: ISaldoInicialImportacaoJsonItemRequest[]) {
		this.loading_deferred = this.$q.defer();

		return this.$q<ISaldoInicialImportacaoJsonItemResponse[]>((resolve, reject) => {
			this.$http.post<ISaldoInicialImportacaoJsonItemResponse[]>(
				this.nsjRouting.generate('apuracoesponto_importar_saldo_inicial_json', { apuracaoponto }, true),
				itens,
				{ timeout: this.loading_deferred.promise }
			)
			.then((response) => {
                this.$rootScope.$broadcast('apuracoesponto_importar_saldo_inicial_json_loaded', response);
				resolve(response.data);
			})
				.catch((error) => {
                this.$rootScope.$broadcast('apuracoesponto_importar_saldo_inicial_json_error', error);
					reject(error);
				});
		});
	}

	importarSaldoInicialArquivo(apuracaoponto: string, fileextension: 'csv' | 'xlsx', arquivoBase64: string) {
		this.loading_deferred = this.$q.defer();

		return this.$q<ISaldoInicialImportacaoArquivoResponse>((resolve, reject) => {
			this.$http.post<ISaldoInicialImportacaoArquivoResponse>(
				this.nsjRouting.generate('apuracoesponto_importar_saldo', { apuracaoponto, fileextension }, true),
				{ arquivo: arquivoBase64 },
				{ timeout: this.loading_deferred.promise }
			)
			.then((response) => {
                this.$rootScope.$broadcast('apuracoesponto_importar_saldo_loaded', response);
				resolve(response.data);
			})
				.catch((error) => {
                this.$rootScope.$broadcast('apuracoesponto_importar_saldo_error', error);
					reject(error);
				});
		});
	}
}
